// extracted by mini-css-extract-plugin
export default {"wrapper":"s2-z","play":"t2-z"};